import dayjs from 'dayjs'
import PropertyTag from './PropertyTag'
import { formatDuration } from '@ivy-monorepo/shared'

interface FormItemProps {
  label: string
  value: any
  type?: 'date' | 'datetime' | 'telephone' | 'dateAndAge' | 'genderPreference' | 'email' | 'interval'
  className?: string
  onClick?: () => void
  formattedValue?: React.ReactNode
}

const formatValue = (value: any, type?: FormItemProps['type']) => {
  if (!type) return value

  const formatters = {
    date: () => dayjs.utc(value).format('MMM DD, YYYY'),
    datetime: () => dayjs(value).format('MMM DD, YYYY [at] hh:mma'),
    email: () => (
      <a className="link" href={`mailto:${value}`}>
        {value}
      </a>
    ),
    dateAndAge: () => {
      const dob = /^\d{2}-\d{2}-\d{4}$/.test(value) ? dayjs.utc(value, 'MM-DD-YYYY') : dayjs.utc(value)
      return (
        <>
          {dob.format('MMM DD, YYYY')} ({dayjs().diff(dob, 'year')} years old)
        </>
      )
    },
    genderPreference: () => (
      <>
        <PropertyTag value={value[0]} />
        &nbsp;&nbsp;seeking&nbsp;&nbsp;
        {
          !Array.isArray(value[1])
            ? <PropertyTag value={value[1]} />
            : value[1].map((g) => <PropertyTag key={g} value={g} />)
        }
      </>
    ),
    telephone: () => value.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3'),
    interval: () => {
      return formatDuration(value)
    },
  }

  return formatters[type]?.() ?? value
}

const FormItem = ({ label, value, type, className, onClick, formattedValue }: FormItemProps) => {
  return (
    <li className={`form-item ${className ?? ''}`}>
      <label>{label}</label>
      <p onClick={onClick}>{formattedValue ?? formatValue(value, type)}</p>
    </li>
  )
}

export default FormItem
